
        // match container heights with the same data-match-heights value
        function matchContainerHeights() {
            const matchHeights = document.querySelectorAll('[data-match-heights]');
            matchHeights.forEach((container) => {
                container.removeAttribute('style');
            });
            [0,100].forEach((time) => {
                setTimeout(() => {

                    matchHeights.forEach((container) => {
                        // reset style attribute
                        const matchHeights_Value = container.getAttribute('data-match-heights'),
                            matchHeights_Containers = document.querySelectorAll(`[data-match-heights="${matchHeights_Value}"]`),
                            matchHeights_ContainersArray = Array.from(matchHeights_Containers),
                            matchHeights_ContainersHeights = matchHeights_ContainersArray.map((container) => container.offsetHeight),
                            matchHeights_ContainersMaxHeight = Math.max(...matchHeights_ContainersHeights),
                            matchHeights_Breakpoint = matchHeights_Value.split(':')[0];
                        let  bp_sm = 640,
                            bp_md = 768,
                            bp_lg = 1024,
                            bp_xl = 1280,
                            bp_2xl = 1536
                        if (matchHeights_Breakpoint === 'sm') {
                            minW = bp_sm;
                        } else if (matchHeights_Breakpoint === 'md') {
                            minW = bp_md;
                        } else if (matchHeights_Breakpoint === 'lg') {
                            minW = bp_lg;
                        } else if (matchHeights_Breakpoint === 'xl') {
                            minW = bp_xl;
                        } else if (matchHeights_Breakpoint === '2xl') {
                            minW = bp_2xl;
                        } else {
                            minW = 0;
                        }
                        if(window.innerWidth < minW) return;
                        matchHeights_Containers.forEach((container) => {
                            container.style.height = `${matchHeights_ContainersMaxHeight}px`;
                        });
                    });

                }, time);
            });
        }
        // run once dom has loaded
        document.addEventListener('DOMContentLoaded', function() {
            matchContainerHeights();
        });
        // run on window resize
        window.addEventListener('resize', function() {
            matchContainerHeights();
        });